import React from 'react';
import NotificationSVG from 'Components/Admin/assets/NotificationSVG';

const Message = ({ type, title, message }) => {
  return (
    <div className="toast-message">
      <div className="toast-message__title">
        <div className="toast-message__icon"><NotificationSVG type={type} /></div>
        <div>{title}</div>
      </div>
      {message && <p className="toast-message__message">{message}</p>}
    </div>
  );
};

export default Message;
